/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Login_Disable_Login_ScreenInputs */

const en_forms_users_settings_login_disable_login_screen = /** @type {(inputs: Forms_Users_Settings_Login_Disable_Login_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screen`)
};

const de_forms_users_settings_login_disable_login_screen = /** @type {(inputs: Forms_Users_Settings_Login_Disable_Login_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldebildschirm deaktivieren`)
};

/**
* | output |
* | --- |
* | "Screen" |
*
* @param {Forms_Users_Settings_Login_Disable_Login_ScreenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_login_disable_login_screen = /** @type {((inputs?: Forms_Users_Settings_Login_Disable_Login_ScreenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Login_Disable_Login_ScreenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_login_disable_login_screen(inputs)
	return de_forms_users_settings_login_disable_login_screen(inputs)
});